import LawFirmTeams from "./LawFirmTeams";

export default LawFirmTeams;
